module.exports = __webpack_public_path__ + "static/icons/icon-caret-down-bold-d0b8169f621b71b2827f40e32d704764.svg";